<script setup lang="ts">
    import { SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/shared/ui/Sidebar';
    import { useApplicationStore } from '@/stores/application.store';

    const appStore = useApplicationStore();
</script>

<template>
    <SidebarHeader class="flex h-16 justify-center px-4 border-b border-border-subdued header">
        <SidebarMenu>
            <SidebarMenuItem>
                <SidebarMenuButton
                    class="logo px-0! hover:bg-background-primary"
                    as-child
                    :style="{ padding: '0px !important' }"
                >
                    <RouterLink :to="'/'">
                        <img
                            :src="appStore.tenant.squareLogoUrl ?? appStore.tenant.logoUrl"
                            class="flex aspect-square size-9 rounded-lg"
                        />
                        <div class="text-sm font-semibold">{{ appStore.tenantInfo.name }}</div>
                    </RouterLink>
                </SidebarMenuButton>
            </SidebarMenuItem>
        </SidebarMenu>
    </SidebarHeader>
</template>

<style lang="css" scoped>
    .header .logo {
        padding: 0 !important;
        min-width: 36px;
        min-height: 36px;
    }
</style>
